import {IUpdateEmail, IUpdatePassword, IUserProfile} from '../../../../coreGlobal/models/user'

export const profileDetailsInitValues: IUserProfile = {
  name: '',
  cpf: '',
  phone: '',
  notification_preference: 0,
}

export const updateEmail: IUpdateEmail = {
  newEmail: '',
  confirmPassword: '',
}

export const updatePassword: IUpdatePassword = {
  currentPassword: '',
  newPassword: '',
  passwordConfirmation: '',
}
